import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import SigningContractAgentImage from 'assets/images/SigningContractAgentImage.png';
import AgentESignCustomizedSteppers from 'modules/private/BuyerDashboard/CustomStepper';
import {
  POST_AGENT_BANNER_CLOSE,
  POST_AGENT_BANNER_VIEW,
} from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import { datacontext } from 'modules/AppLayout/AppLayout';

const Step6VendorSignedContractOfSale = (props) => {
  const {
    bannerDetails,
    isAgentDashboard,
    AgentGroupCall,
    getListInfo,
    pauseBannerVendor,
    setVendorSignedContractClose,
    propertyAddress,
    propertyId,
    isAgentVendorContractViewedCompleted,
  } = props;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const { bannerApiTrigger } = useContext(datacontext);

  const getOwnerFullName = (ownerDetails) => {
    return `${ownerDetails?.user?.userName} ${ownerDetails?.user?.userSurName}`;
  };
  const ownerFullName = getOwnerFullName(bannerDetails);

  const getOwnerIds = (ownerDetails) => {
    return ownerDetails?.user?.userId;
  };
  const ownerId = getOwnerIds(bannerDetails);

  const vendorName = ownerFullName;

  const isContractViewcompleted = isAgentVendorContractViewedCompleted === 0;

  let viewInput = {
    propertyId: propertyId,
    isViewed: 1,
    bannerCode: 'AGENT002',
    vendorId: ownerId,
    bannerHeading: 'Vendor not yet Signed - Sign Contract Viewed',
  };

  useEffect(() => {
    if (pauseBannerVendor && isContractViewcompleted) {
      postApiCall(POST_AGENT_BANNER_VIEW, viewInput);
      if (!isAgentDashboard) {
        getListInfo();
      }
      if (isAgentDashboard) {
        AgentGroupCall();
      }
    }
  }, [pauseBannerVendor, isContractViewcompleted]);

  const [closeLoader, setCloseLoader] = useState(false);
  const handleVendorSignedcontractCloseApiCall = async () => {
    let input = {
      propertyId: propertyId,
      bannerCode: 'AGENT002',
      vendorId: ownerId,
      bannerHeading: 'Vendor not yet Signed - Sign Contract Viewed',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_AGENT_BANNER_CLOSE, input);
      bannerApiTrigger();

      if (response?.data?.status == 1) {
        setVendorSignedContractClose((prev) =>
          prev.includes(ownerId) ? prev : [...prev, ownerId]
        );
        if (!isAgentDashboard) {
          getListInfo();
        }
        if (isAgentDashboard) {
          AgentGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: '#A444AD',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 20px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '10px 10px 0 10px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: 300,
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {propertyAddress}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: 1,
                  }}
                >
                  {vendorName} - has Signed the Contract of Sale
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Excellent! The Vendor{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {vendorName}
                  </Typography>
                  &nbsp; has signed the Contract of Sale.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 10px 0 10px' : '0 0 0 33px',
                }}
              >
                <Button
                  disabled={closeLoader}
                  onClick={handleVendorSignedcontractCloseApiCall}
                  endIcon={
                    closeLoader && (
                      <CircularProgress size="20px" sx={{ color: 'white' }} />
                    )
                  }
                  sx={{
                    px: 4,
                    height: matchessm ? 35 : 42,
                    borderRadius: '5px',
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: 'transparent',
                    color: '#E6F2FF',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    '&:hover': {
                      bgcolor: 'transparent',
                      color: '#E6F2FF',
                    },
                  }}
                >
                  Close
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <AgentESignCustomizedSteppers
                  stepValue={4}
                  requestEsign={true}
                />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={SigningContractAgentImage}
                alt="SigningContractAgentImage"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );
};

export default Step6VendorSignedContractOfSale;
